<template>
  <section
    class="slide sec3 whiteSlide kenBurns bg-white overflow-hidden opacity-0 fixed w-full h-full text-black"
  >
    <div class="content overflow-hidden absolute left-0 top-0 w-full h-full z-20">
      <div class="container max-w-full table w-full h-full table relative table-fixed">
        <div class="wrap cursor-default table-cell align-middle">
          <div class="fix-width max-w-1114px ml-auto mr-auto">
            <ul class="grid sec-details sec-details2 ml-spc16 mr-spc16">
              <li
                class="col-6-12 mt-spc13 max-w-589 w-full pl-6 pr-6 block text-center"
                id="productImage1"
              >
                <SliderOne :slideDatas="mjSliderData" />
              </li>
              <li class="col-6-12 left max-w-589 w-full pl-6 pr-6 block">
                <SectionDetailsContent
                  :title="title"
                  :subtitle="subtitle"
                  :sizes="sizes"
                  :prices="prices"
                  :colors="colors"
                  :fabrics="fabrics"
                  btn1title="Purchase"
                  btn2title="Enquiries"
                />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SliderOne from "../sliders/slider1/SliderOne";
import SectionDetailsContent from "../common/SectionDetailsContent";

let mjSliderData = {
  sliderID: "32",
  mjSliders: [
    {
      active: true,
      img: require("@/assets/images/products/thumbapron1.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbapron2.png")
    },
    {
      active: false,
      img: require("@/assets/images/products/thumbapron3.png")
    }
  ]
};

export default {
  name: "Section12",
  components: {
    SectionDetailsContent,
    SliderOne
  },
  data: function() {
    return {
      mjSliderData,
      title: "THE FIELD APRON",
      subtitle: "GET MUDDY",
      sizes: {
        sizetitle: "SIZES AND STYLES",
        sticks: "One Size",
        sticks2: "4 Linen Pockets f",
        stickoutland: "2 Natural Leather Pocket t"
      },
      colors: {
        colortitle: "COLORS",
        clr: "Glorious Mud M",
        clr2: "White, Blue or Copper Patent Leather W, B, C",
        clr3: "or Natural Leather L"
      },
      fabrics: {
        fabrictitle: "FABRIC",
        fabric: "Hand-Dyed UK Line",
        fabric2: "Hand-dyed colors vary wildly"
      },
      prices: {
        pricestitle: "UNIT PRICE",
        price1: "$160 with 4 Linen Pockets f",
        price2: "$189 with 2 Leather Pockets l"
      }
    };
  }
};
</script>

<style scoped>
</style>